<template>
  <div class="pager" v-if="page.totalElements > 0">
    <div class="pager__size">
      <span>Sayfa Başına</span>
      <select
        v-model="pageSize"
        class="pager__size-select"
        id="pager__size-select"
      >
        <option value="5">5</option>
        <option value="10">10</option>
        <option value="20">20</option>
      </select>
      <span>satır</span>
    </div>
    <ul class="pager__items">
      <li class="pager__item-text">
        <a
          id="controls-first-page"
          :class="{ disabled: page.pageNumber === 1 }"
          @click="setPage(1)"
        >
          <base-icon name="controls-first-page" />
        </a>
      </li>
      <li class="pager__item-text">
        <a
          id="controls-backward"
          :class="{ disabled: page.pageNumber === 1 }"
          @click="setPage(page.pageNumber - 1)"
        >
          <base-icon name="controls-backward" />
        </a>
      </li>
      <li
        v-for="n in page.totalPages"
        :key="n"
        class="pager__item-number"
        :class="{ active: page.pageNumber === n }"
      >
        <span :id="'pager__item-number-' + n" @click="setPage(n)">{{ n }}</span>
      </li>
      <li class="pager__item-text">
        <a
          id="controls-forward"
          :class="{ disabled: page.pageNumber === page.totalPages }"
          @click="setPage(page.pageNumber + 1)"
        >
          <base-icon name="controls-forward" />
        </a>
      </li>
      <li class="pager__item-text">
        <a
          id="controls-last-page"
          :class="{ disabled: page.pageNumber === page.totalPages }"
          @click="setPage(page.totalPages)"
        >
          <base-icon name="controls-last-page" />
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import { BaseIcon } from "@/components";

export default {
  name: "Pager",
  components: {
    BaseIcon,
  },
  props: {
    page: Object,
    pageName: String,
  },
  data() {
    return {
      pageSize: 5,
    };
  },
  watch: {
    pageSize(size) {
      size = parseInt(size);
      this.setGeneralFilter({ page: 1, size });
      this.setRecommendedFilter({ page: 1, size });
      if (this.pageName === "dataRequest") {
        this.getRecommendedAllPackageList();
      } else if (this.pageName === "history") {
        this.getHistoryList();
      } else if (this.pageName === "represReports") {
        this.getRepresentativeReport();
      } else if (this.pageName === "invoice") {
        this.getInvoiceList();
      }
    },
  },
  methods: {
    ...mapActions([
      "getRecommendedAllPackageList",
      "getHistoryList",
      "getRepresentativeReport",
      "getInvoiceList",
    ]),
    ...mapMutations(["setGeneralFilter", "setRecommendedFilter"]),
    ...mapGetters(["generalFilter"]),
    scroll() {
      const el = document.getElementById("content");
      const topData = document.getElementById(this.pageName);
      if (el || topData) {
        this.$nextTick(() => {
          el.scrollTo({
            top: topData ? topData.offsetTop : el.offsetTop,
            left: 0,
            behavior: "smooth",
          });
        });
      }
    },
    setPage(page) {
      page = parseInt(page);
      this.setGeneralFilter({ page: page, size: Number(this.pageSize) });
      if (this.pageName == "dataRequest") {
        this.setRecommendedFilter({ page: page, size: Number(this.pageSize) });
        this.getRecommendedAllPackageList().then(() => {
          this.scroll();
        });
      } else if (this.pageName == "history") {
        this.getHistoryList().then(() => {
          this.scroll();
        });
      } else if (this.pageName == "represReports") {
        this.getRepresentativeReport().then(() => {
          this.scroll();
        });
      } else if (this.pageName == "invoice") {
        this.getInvoiceList().then(() => {
          this.scroll();
        });
      }
    },
  },
  mounted() {
    this.setRecommendedFilter({ page: 1, size: 5 });
  },
};
</script>

<style lang="scss" scoped>
.pager {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  font-size: 14px;
  margin-top: 20px;
  .disabled {
    pointer-events: none;
  }
  &__size,
  &__items {
    display: flex;
    align-items: center;
  }
  &__size {
    margin-right: 30px;
    span {
      padding: 0 12px;
    }
  }
  &__items {
    list-style: none;
  }
  &__item-number {
    color: var(--grayscale-70);
    cursor: pointer;
    span {
      padding: 11px 16px;
      display: block;
    }
    &.disabled {
      color: var(--grayscale-50);
    }
    &.active {
      background-color: var(--color-primary-default);
      color: var(--grayscale-0);
      border-radius: var(--radius-first);
    }
  }
  &__item-text {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  &__size-select {
    width: 74px;
    height: 40px;
    padding-left: 7px;
    border-radius: var(--radius-first);
    border-color: var(--grayscale-50);
  }
}
</style>
